import * as React from 'react'
import NewReport from '../../model/NewReport'
import { ButtonGroup, Button, Form, Container, Badge } from 'react-bootstrap'
import SiteConfig from '../../model/SiteConfig'
import Report from '../../model/Report'
import { ReportRouteProps } from '../Router/Router'
import ReportGroup from '../../model/ReportGroup'
import Market from '../../model/Market'
import { ReportGroupSelectionContainer } from '../ReportGroupSelection/ReportGroupSelectionContainer'
import { FaBolt } from 'react-icons/fa'

export interface Fields {
  reportGroupsLoading: boolean
  reportGroup: ReportGroup | undefined
  sites: SiteConfig[]
  sitesLoading: boolean
  markets?: _.Dictionary<Market>
  marketsLoading: boolean
}

export interface Events {
  onSubmit: (market: string, reportGroup: string, report: NewReport) => Promise<Report[]>
}

type State = {
  site?: SiteConfig
  file?: File
  period?: 'Monthly' | 'Quarterly' | 'Yearly'
  startDate?: string
}

type Props = Events & Fields & ReportRouteProps

export class AddReportComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  public render() {
    return (
      <div>
        <ReportGroupSelectionContainer
          market={this.props.reportGroup && this.props.reportGroup.marketKey}
          reportGroup={this.props.reportGroup && this.props.reportGroup.key}
          additionalRoute="/new"
        />
        <Container>
          {this.props.reportGroupsLoading ? (
            <Badge>
              <FaBolt />
              Loading Report Groups...
            </Badge>
          ) : this.props.marketsLoading ? (
            <Badge>
              <FaBolt /> Loading Markets...
            </Badge>
          ) : this.props.reportGroup && this.props.markets ? (
            <p>
              Add a new report for {this.props.markets[this.props.reportGroup.marketKey].name}:{' '}
              {this.props.reportGroup.name}
            </p>
          ) : (
            <p className="alert alert-danger">Unknown report group</p>
          )}
          <Form
            onSubmit={(event:React.FormEvent<HTMLFormElement>) => {
              event.preventDefault()
              const { file, site, startDate, period } = this.state
              const { reportGroup } = this.props
              if (!reportGroup) {
                window.confirm('You must select a report group')
              } else if (!file) {
                window.confirm('You must select a file')
              } else if (
                file.name.toLowerCase().endsWith('.pdf') ||
                window.confirm(
                  'Selected file is not a pdf file, are you sure you want to upload it?'
                )
              ) {
                var report = new NewReport(file)
                report.site = site && site.key
                report.startDate = startDate
                report.period = period

                this.props
                  .onSubmit(reportGroup.marketKey, reportGroup.key, report)
                  .then(() => {
                    this.props.history.push(`/reports/${reportGroup.marketKey}/${reportGroup.key}`)
                  })
                  .catch(reason => window.confirm(reason))
              }
            }}
          >
            <Form.Group>
              <Form.Label>File</Form.Label>
              <Form.Control
                as="input"
                type="file"
                accept=".pdf"
                onChange={(e:React.FormEvent<HTMLInputElement>) =>
                  this.setState({
                    file:
                      (e.currentTarget.files &&
                      e.currentTarget.files.length > 0 &&
                      e.currentTarget.files[0]) || undefined
                  })
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Period</Form.Label>

              <Form.Control
                style={{ height: 32 }}
                as="select"
                value={this.state.period}
                onChange={(e:React.FormEvent<HTMLSelectElement>) => {
                  const period = e.currentTarget.value
                  if (
                    period === 'Monthly' ||
                    period === 'Quarterly' ||
                    period === 'Yearly' ||
                    period === undefined
                  )
                    this.setState({ period })
                }}
              >
                <option key="" value={undefined}>
                  None
                </option>
                <option key="Monthly" value="Monthly">
                  Monthly
                </option>
                <option key="Quarterly" value="Quarterly">
                  Quarterly
                </option>
                <option key="Yearly" value="Yearly">
                  Yearly
                </option>
              </Form.Control>
            </Form.Group>

            <Form.Group>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                value={this.state.startDate}
                onChange={(e:React.FormEvent<HTMLInputElement>) => 
                  this.setState({ startDate: e.currentTarget.value })
                }
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Site</Form.Label>
              {this.props.sitesLoading ? (
                <Badge>
                  <FaBolt /> Loading sites...
                </Badge>
              ) : (
                <Form.Control
                  value={this.state.site && this.state.site.key}
                  onChange={e =>
                    this.setState({
                      site: this.props.sites.find(s => s.key === e.currentTarget.value)
                    })
                  }
                  style={{ height: 32 }}
                  as="select"
                >
                  <option key="" value="">
                    None
                  </option>
                  {this.props.sites
                    .sort((configA, configB) => configA.name.localeCompare(configB.name))
                    .map(config => (
                      <option key={config.key} value={config.key}>
                        {config.name}
                      </option>
                    ))}
                </Form.Control>
              )}
            </Form.Group>

            <ButtonGroup>
              <Button type="submit" variant="primary">
                OK
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  if (this.props.reportGroup) {
                    this.props.history.push(
                      `/reports/${this.props.reportGroup.marketKey}/${this.props.reportGroup.key}`
                    )
                  }
                }}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </Form>
        </Container>
      </div>
    )
  }
}
